import React from 'react';
import { Icon } from '../icons';
import NotificationBell from './NotificationBell';

// Barra in alto: titolo della sezione corrente e notifiche. L'utente e il tasto
// "Esci" stanno nel piede della sidebar (vedi Sidebar.js), non qui.
function Header({ title, subtitle, onToggleMenu, notifications, unread, onOpenNotification }) {
  return (
    <header className="topbar">
      <button className="icon-btn menu-btn" onClick={onToggleMenu} aria-label="Apri menu">
        <Icon name="menu" />
      </button>

      <div className="topbar-title">
        <h1>{title}</h1>
        {subtitle && <span>{subtitle}</span>}
      </div>

      <div className="topbar-actions">
        {/* Il campanello compare solo a chi puo' ricevere almeno un tipo di
            notifica (vedi RECEIVES_NOTIFICATIONS in App.js): per gli altri
            ruoli App passa `notifications` null. */}
        {notifications && (
          <NotificationBell
            notifications={notifications}
            unread={unread}
            onOpenNotification={onOpenNotification}
          />
        )}
      </div>
    </header>
  );
}

export default Header;
